import React, { useEffect } from 'react';
import moment from 'moment';
import { Badge } from 'react-bootstrap';

import useGlobal from '../../../store';
import Str from '../../../support/Str';
import Table from '../../../facturotopia/table/Table';

const mapState = (store) => {
  return {
    audits: store.developer.stamping.retenciones,
  };
};

const mapActions = (actions) => {
  return { ...actions.developer.stamping.retenciones };
};

const TimbradoRetencionList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.audits;

  useEffect(() => {
    if (data.length === 0) {
      const from = moment().subtract(7, 'days').format('YYYY-MM-DD');
      const to = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        from,
        to,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    const { from = '', to = '' } = state.developer.stamping.filters;

    const newMeta = {
      ...meta,
      from,
      to,
    };

    actions.paginate(newMeta);
  };

  const handleOnPageChange = (page) => {
    paginate({ page });
  };

  const handleOnPageLimitChange = (limit) => {
    paginate({ limit, page: 1 });
  };

  const getPaginationConfig = () => {
    const { pagination } = state.audits;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      pagination={getPaginationConfig()}
      onRowClick={onRowClick}
      onRow={(item) => {
        return {
          className: item.highlight ? 'row-highlighted' : '',
        };
      }}
    ></Table>
  );
};

const renderSerieFolio = (item) => {
  let serie = item.serie ? item.serie : '';

  if (!!serie) {
    return <span>{`${item.serie} / ${item.folio}`}</span>;
  }

  return <span>{item.folio}</span>;
};

const renderIdx = (item) => {
  return <span>{Str.only(item.idx, 10)}</span>;
};

const renderStatus = (item) => {
  const { status } = item;

  let variant = 'info';

  switch (status) {
    case 'processing':
      variant = 'info';
      break;

    case 'done':
      variant = 'success';
      break;

    case 'error':
      variant = 'danger';
      break;

    default:
      break;
  }

  return <Badge variant={variant}>{item.status}</Badge>;
};

const columns = [
  {
    key: 'created_at',
    title: 'Request',
    dataIndex: 'created_at',
  },
  {
    key: 'idx',
    title: 'Idx',
    dataIndex: 'idx',
    render: renderIdx,
  },
  {
    key: 'tipo',
    title: 'Clave',
    dataIndex: 'cveretenc',
    className: 'text-center',
  },
  {
    key: 'emisor',
    title: 'Emisor',
    dataIndex: 'emisor_rfc',
  },
  {
    key: 'receptor',
    title: 'Receptor',
    dataIndex: 'receptor_rfc',
  },
  {
    key: 'serie',
    title: 'Serie/Folio',
    className: 'text-right',
    render: renderSerieFolio,
  },
  {
    key: 'monto_operacion',
    title: 'M. Operación',
    dataIndex: 'monto_operacion',
    className: 'text-right',
  },
  {
    key: 'monto_retenido',
    title: 'M. Retenido',
    dataIndex: 'monto_retenido',
    className: 'text-right',
  },
  {
    key: 'intentos',
    title: 'Intentos',
    dataIndex: 'intentos',
    className: 'text-right',
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    className: 'text-center',
    render: renderStatus,
  },
];

export default TimbradoRetencionList;
